export default __webpack_public_path__ + "static/media/apna.268edb9e.gif";